import React, { useContext } from 'react';
import { addFollow, withFollow, FollowButton } from '@eb/follow-organizer-ebui';

import { UserContext, EnvContext } from '../context';
import { Organizer } from '../types';

interface FollowOrganizerWidgetProps {
    gaSettings: object;
    gaCategory: string;
    organizers: Organizer[];
    isAuthenticated: boolean;
}

const EnhancedFollowButton = withFollow(FollowButton);
const FollowOrganizerWidget: React.FunctionComponent<FollowOrganizerWidgetProps> = (
    props,
) => {
    return (
        <EnhancedFollowButton
            isOnlyButton={true}
            organizerId={props.organizers[0]}
        />
    );
};

interface FollowOrganizerProps {
    organizer: Organizer;
}

const EnhancedFollowOrganizerWidget = addFollow(FollowOrganizerWidget);
export const FollowOrganizer: React.SFC<FollowOrganizerProps> = (props) => {
    const { isAuthenticated } = useContext(UserContext);
    const { gaSettings } = useContext(EnvContext);

    return (
        <EnhancedFollowOrganizerWidget
            isAuthenticated={isAuthenticated}
            gaSettings={gaSettings}
            gaCategory={'organizer'}
            organizers={[props.organizer.id]}
        />
    );
};
